__turbopack_context__.v({
  "modalButtonRow": "DMOptOutFormContainer-module-scss-module__RvqRPG__modalButtonRow",
});
